import { render } from "./detail.vue?vue&type=template&id=5f5eb594&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"

import "./detail.vue?vue&type=style&index=0&id=5f5eb594&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5eb594"]])

export default __exports__